export const GET_ALL_SPEAKER = "GET_ALL_SPEAKER";
export const GET_ALL_LANGUAGE = "GET_ALL_LANGUAGE";
export const GET_ALL_COLOR = "GET_ALL_COLOR";
export const GET_ALL_KEYWORD = "GET_ALL_KEYWORD";
export const GET_ALL_CATEGORY = "GET_ALL_CATEGORY";
export const GET_ALL_LIST_DATA = "GET_ALL_LIST_DATA";
export const GET_ALL_EVENT = "GET_ALL_EVENT";
export const GET_ALL_CONTENT_TYPE = "GET_ALL_CONTENT_TYPE";
export const GET_ALL_CONTENT_CREATOR = "GET_ALL_CONTENT_CREATOR";
export const GET_ALL_CONTENT_TEMPLATES = "GET_ALL_CONTENT_TEMPLATES";
export const GET_ALL_CONTENT_DIMENSIONS = "GET_ALL_CONTENT_DIMENSIONS";

